import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Table = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).border.color,
}));

export const Root = styled.div<{ sticky?: boolean }>(
    props =>
        props.sticky && {
            position: "relative",
            zIndex: 100,
            boxShadow: `0 -3px 5px 1px ${props.theme.candy.legacy.shadowColor}`,
        }
);
